import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import { NavLink, useNavigate } from "react-router-dom";
import SvgImage from "../../../../../Icons/Icons";
import "./index.css";
import moment from "moment";
import AddNewVendor from "../../../../Components/AddNewVendor";
import {
  getVendorLedger,
  clearVendorLedger,
  getTripsNew,
} from "../../../../../../services/Store/Actions/TripsAction";
import { wait } from "@testing-library/user-event/dist/utils";
import NoTransaction from "../../../../../ManageDriver/SubComponents/NewDriverSideSection/SubComponents/TabularData/NoTransaction";
import { ClipLoader } from "react-spinners";
import { BallTriangle } from "react-loader-spinner";
import { storeDataToAsyncStorage } from "../../../../../../services/Utils/functions";

function VendorTrips(props) {
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(0);
  const [offset, setOffset] = useState(0);
  const [enterPin, setEnterPin] = useState(false);
  const [paymentData, setPaymentData] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [failedModal, setFailedModal] = useState(false);
  const [failedMsg, setFailedMsg] = useState();
  const [editDetails, setEditDetails] = useState(false);
  const [paymetModal, setPaymentModal] = useState(false);
  const [fleetModal, setFleetModal] = useState(false);
  const [successText, setSuccessText] = useState("");
  const [pinLoader, setPinLoader] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const {startDate, endDate} = props

  const [show, setShow] = useState(true);
  const [isCheckAllTrips, setIsCheckAllTrips] = useState(false);
  const [isCheckTransfer, setIsCheckTransfer] = useState({});
  const [isCheckTransferLength, setIsCheckTransferLength] = useState(0);
  const [tripType, setTripType] = useState("");

  let { tripsListNew, tripsCount, fetchingTrips } = useSelector(
    (store) => store?.trip
  );
  const navigate = useNavigate();
  const { vendorData, path, setShowVendor } = props;
  //   const isLogipeVendor = path == "0" || path == "1" || path == "2" ? "1" : "0";
  useEffect(()=> {
    setOffset(0)
  },[startDate,endDate])
  
  const dispatch = useDispatch();
  const trxnCount = tripsCount;
  console.log("vendorTransactioffffnList", tripsListNew);
  const handlePrev = () => {
    if (offset > 0) {
      //   dispatch(cleanVendorTransaction());
      setOffset(offset - 5);
      dispatch(
        getTripsNew({
          offset: offset + 5,
          limit: 5,
          vendorId: vendorData?.id,
          startDateFrom: startDate == "Invalid date" || "" ? "" : moment(startDate,'YYYY/MM/DD').format('YYYY/MM/DD'),
          startDateTo: endDate == "Invalid date" || "" ? "" :moment(endDate,'YYYY/MM/DD').format('YYYY/MM/DD'),
          isActive:
            tripType == "0"
              ? 2
              : tripType == "1"
              ? 3
              : tripType == "2"
              ? 1
              : tripType == "3"
              ? 5
              : tripType == "4"
              ? 9
              : "",
        })
      );
    }
  };

  // useEffect(() => {

  // },[isCheckTransferLength])
  const handleNext = () => {
    console.log("offset,trxnCount", offset, trxnCount);
    if (offset + 5 < trxnCount) {
      // dispatch(clearVendorLedger());
      setOffset(offset + 5);
      dispatch(
        getTripsNew({
          offset: offset + 5,
          limit: 5,
          vendorId: vendorData?.id,
          startDateFrom: startDate == "Invalid date" || "" ? "" : moment(startDate,'YYYY/MM/DD').format('YYYY/MM/DD'),
          startDateTo: endDate == "Invalid date" || "" ? "" :moment(endDate,'YYYY/MM/DD').format('YYYY/MM/DD'),
          isActive:
            tripType == "0"
              ? 2
              : tripType == "1"
              ? 3
              : tripType == "2"
              ? 1
              : tripType == "3"
              ? 5
              : tripType == "4"
              ? 9
              : "",
        })
      );
    }
  };

  useEffect(() => {
    dispatch(
      getTripsNew({
        offset: offset,
        limit: 5,
        vendorId: vendorData?.id,
        startDateFrom: startDate == "Invalid date" || "" ? "" : moment(startDate,'YYYY/MM/DD').format('YYYY/MM/DD'),
        startDateTo: endDate == "Invalid date" || "" ? "" :moment(endDate,'YYYY/MM/DD').format('YYYY/MM/DD'),
        isActive:
          tripType == "0"
            ? 2
            : tripType == "1"
            ? 3
            : tripType == "2"
            ? 1
            : tripType == "3"
            ? 5
            : tripType == "4"
            ? 9
            : "",
      })
    );
  }, [tripType, startDate, endDate]);

  const datepickerRefStart = useRef();
  const handleClickDatepickerIcon1 = () => {
    const datepickerElement = datepickerRefStart.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };
  const datepickerRefEnd = useRef();
  const handleClickDatepickerIcon2 = () => {
    const datepickerElement = datepickerRefEnd.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };
  function findSearch() {}
  if (editDetails) {
    return (
      <AddNewVendor
        backPress={() => {
          setEditDetails(false);
          setShowVendor(false);
        }}
        oldDetails={vendorData}
        path={path}
      />
    );
  } else {
    return (
      <div className="vendorBg containerShadow">
        <div className="row box3 justify-content-between">
          <div className="col-12 col-md-10">
            <button
              className={`Medium heading3 ${
                tripType == "" ? "greenButtonMini" : "greenOutlineButtonMini"
              } rounded-pill`}
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              onClick={(e) => {
                setTripType("");
              }}
            >
              All
            </button>
            <button
              className={`Medium heading3 ${
                tripType == "0" ? "greenButtonMini" : "greenOutlineButtonMini"
              } rounded-pill ms-3`}
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              onClick={(e) => {
                setTripType("0");
                // setOffset(0);
              }}
            >
              Running
            </button>
            <button
              className={`Medium heading3 ${
                tripType == "1" ? "greenButtonMini" : "greenOutlineButtonMini"
              } rounded-pill ms-3`}
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              onClick={(e) => {
                setTripType("1");
                // setOffset(0);
              }}
            >
              Completed
            </button>
            <button
              className={`Medium heading3 ${
                tripType == "2" ? "greenButtonMini" : "greenOutlineButtonMini"
              } rounded-pill ms-3`}
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              onClick={(e) => {
                setTripType("2");
                // setOffset(2);
              }}
            >
              Not started
            </button>
            <button
              className={`Medium heading3 ${
                tripType == "3" ? "greenButtonMini" : "greenOutlineButtonMini"
              } rounded-pill ms-3`}
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              onClick={(e) => {
                setTripType("3");
                // setOffset(3);
              }}
            >
              Idle
            </button>
            <button
              className={`Medium heading3 ${
                tripType == "4" ? "greenButtonMini" : "greenOutlineButtonMini"
              } rounded-pill ms-3`}
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
              onClick={(e) => {
                setTripType("4");
                // setOffset(3);
              }}
            >
              Delayed
            </button>
          </div>
          <div className="col-12 col-md-2 align-items-center">
            <button
              className=" d-flex align-items-center text2 headingText"
              style={{
                border: 0,
                // marginTop: "10px",
                backgroundColor: "#FFFFFF",
              }}
              onClick={() => {
                // setDownload(true);
              }}
            >
              <div className="padding8R">
                <SvgImage name="downloadImgV2" />
              </div>
              Download
            </button>
          </div>
        </div>
        {fetchingTrips ? (
          <div
            className="mt-2 boxContainer"
            style={{
              padding: 70,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <BallTriangle
              height={70}
              width={70}
              radius={5}
              color="#ED752E"
              ariaLabel="ball-triangle-loading"
              wrapperClass={{}}
              wrapperStyle=""
              visible={true}
            />
          </div>
        ) : trxnCount == undefined ? (
          <NoTransaction />
        ) : trxnCount == 0 ? (
          <NoTransaction />
        ) : (
          <>
            <div className="table-for-Vendor mt-0">
              <Table className="vehicleAssignedHistory">
                <thead className="th" style={{ zIndex: 99 }}>
                  <tr className="table-header-vendor-details">
                    <th className="vendor-transaction-header col-1.5">
                      Trip Number
                    </th>
                    <th className="vendor-transaction-header col-2">
                      Vehicle
                    </th>
                    <th className="vendor-transaction-header col-2">From</th>
                    <th className="vendor-transaction-header col-2">
                      To
                    </th>
                    <th className="vendor-transaction-header col-2">
                      Start Date
                    </th>
                    <th className="vendor-transaction-header">Total Expense</th>
                    <th className="vendor-transaction-header">Total Paid</th>
                    <th className="vendor-transaction-header">
                      <div className="row">
                        <div className="col-6">Status</div>
                        {isCheckTransferLength > 0 ? (
                          <div className="col-6" style={{ marginTop: "-2px" }}>
                            <button>MARK</button>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </th>
                    {/* <th className="col-2 vendor-transaction-header">
                    Upload / View Invoice
                  </th> */}
                  </tr>
                </thead>
                {/* <div className="tbodyVehicle-div"> */}
                <tbody
                  className="tbodyVendor"
                  style={{ textDecoration: "none" }}
                >
                  {tripsListNew?.map((items, i) => {
                    console.log("-----------", i);
                    return (
                      <>
                        {
                          <tr className="table-row-vendor-details table-row-transaction-history">
                            <td
                              className="col-1.5 "
                              style={{
                                verticalAlign: "middle",
                                borderRightWidth: 1,
                                cursor: "pointer",
                                textDecorationLine: "underline",
                                color: "blue",
                              }}
                              onClick={() => {
                                storeDataToAsyncStorage("row", items);
                                navigate(`/trips/${items?.tripId}`);
                              }}
                            >
                              {items?.tripNo}
                            </td>
                            <td
                              className="col-2 "
                              style={{
                                verticalAlign: "middle",
                                borderRightWidth: 1,
                              }}
                            >
                              {items?.Fleet?.regNumber ? items?.Fleet?.regNumber : ""}
                            </td>
                            <td
                              className="col-2 "
                              style={{
                                verticalAlign: "middle",
                                borderRightWidth: 1,
                              }}
                            >
                              {items?.source.length == 36
                                ? items?.sourceAddress?.cityName +
                                  ", " +
                                  items?.sourceAddress?.stateName
                                : items?.source}
                            </td>

                            <td
                              className="col-2 "
                              style={{
                                verticalAlign: "middle",
                                borderRightWidth: 1,
                                wordBreak: "break-all",
                              }}
                            >
                              {items?.destination.length == 36
                                ? items?.destAddress?.cityName +
                                  ", " +
                                  items?.destAddress?.stateName
                                : items?.destination}
                            </td>
                            <td
                              className="col-2"
                              style={{
                                verticalAlign: "middle",
                                borderRightWidth: 1,
                                wordBreak: "break-all",
                              }}
                            >
                              {items?.expectedStartTime
                                ? moment(items?.expectedStartTime).format(
                                    "DD MMM YY"
                                  )
                                : ""}
                            </td>
                            <td
                              style={{
                                verticalAlign: "middle",
                                borderRightWidth: 1,
                              }}
                            >
                              ₹{items?.TripExpense?.vendorTotal || "0"}
                            </td>
                            <td
                              className=""
                              style={{
                                verticalAlign: "middle",
                                borderRightWidth: 1,
                                // color:
                                //   items?.status == "Success"
                                //     ? "#09BD7B"
                                //     : "#E63946",
                              }}
                            >
                              ₹{items?.TripExpense?.totalVendorExpense || "0"}
                            </td>
                            <td
                              style={{
                                verticalAlign: "middle",
                                borderRightWidth: 1,
                              }}
                            >
                              <div
                                onClick={() => {
                                  console.log("adsfghwerter");
                                }}
                                style={{
                                  verticalAlign: "middle",
                                  borderRightWidth: 1,
                                  color:
                                    items?.isActive == "1"
                                      ? "#09BD7B"
                                      : "#E63946",
                                }}
                              >
                                {items?.isActive == 2
                                  ? "Running"
                                  : items?.isActive == 1
                                  ? "Not Start"
                                  : "Completed"}
                              </div>
                            </td>
                          </tr>
                        }
                      </>
                    );
                  })}
                </tbody>
                {/* </div> */}
              </Table>
              {/* {
          olderHistoryStatus?
          <div className="olderTransactions-div" onClick={handleOlderTransactions}>
          Older History
          </div>:
        <></>
        } */}
              {trxnCount > 0 && (
                <div className="row margin0 padding16">
                  <div
                    className="col-4"
                    style={{
                      textAlign: "right",
                      paddingTop: "0.1rem",
                      cursor: offset > 0 ? "pointer" : "no-drop",
                      opacity: offset > 0 ? "1" : "0.5",
                    }}
                    onClick={handlePrev}
                  >
                    <SvgImage name="PrevArrow" />
                  </div>
                  <div
                    className="col-1 greenFont semiBold heading4 padding0L"
                    style={{
                      textAlign: "right",
                      paddingTop: "0.3rem",
                      cursor: offset > 0 ? "pointer" : "no-drop",
                      opacity: offset > 0 ? "1" : "0.5",
                    }}
                    onClick={handlePrev}
                  >
                    Previous
                  </div>
                  <div className="col-2 row margin0 justify-content-center">
                    <div
                      className="greenBoxCount Medium heading4 col-4"
                      style={{
                        width: "2rem",
                        height: "2rem",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      {offset / 5 + 1}
                    </div>
                    <div
                      className=" col-4 padding0R"
                      style={{ paddingTop: "0.3rem", textAlign: "right" }}
                    >
                     <div style={{display: "flex", flexDirection: "row"}}>
                      <div>of{" "}</div>
                      <div style={{marginLeft: "10px"}}>{trxnCount % 5 == 0
                      ? Math.floor(trxnCount / 5)
                      : Math.floor(trxnCount / 5 + 1)}</div>
                    </div>
                    
                     
                    </div>
                  </div>
                  <div
                    className="col-1 greenFont semiBold heading4 padding0R"
                    style={{
                      textAlign: "left",
                      paddingTop: "0.3rem",
                      cursor: trxnCount - offset > 5 ? "pointer" : "no-drop",
                      opacity: trxnCount - offset > 5 ? "1" : "0.5",
                    }}
                    onClick={handleNext}
                  >
                    Next
                  </div>
                  <div
                    className="col-4 padding0L"
                    style={{
                      textAlign: "left",
                      marginLeft: "-1rem",
                      paddingTop: "0.1rem",
                      cursor: trxnCount - offset > 5 ? "pointer" : "no-drop",
                      opacity: trxnCount - offset > 5 ? "1" : "0.5",
                    }}
                    onClick={handleNext}
                  >
                    <SvgImage name="NextArrow" />
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}
export default VendorTrips;
